import {Controller} from "@hotwired/stimulus"
import toastr from "toastr"

// Connects to data-controller="toast"
export default class extends Controller {
  static targets = [];

  connect() {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: true,
      progressBar: false,
      positionClass: "toast-top-center",
      preventDuplicates: false,
      onclick: null,
      showDuration: 0,
      hideDuration: 100,
      timeOut: 5000,
      extendedTimeOut: 3000,
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      escapeHtml: false
    };

    this.toastrInstance = this.generateToastr()
    this.toastrInstance[0]?.setAttribute("data-turbo-temporary", "true")
    this.element.remove()
  }

  generateToastr() {
    let toast_key = this.data.get("key");
    let toast_value = this.data.get("value");
    let icon_class = this.data.get("icon-class");

    let message = toast_value;
    if (icon_class && icon_class.trim() !== "") {
      message = `<i class="${icon_class} me-2"></i>${toast_value}`;
    }

    switch (toast_key) {
      case "notice":
      case "success":
        return toastr.success(message);
      case "info":
        return toastr.info(message);
      case "warning":
        return toastr.warning(message);
      case "alert":
      case "error":
        return toastr.error(message);
      default:
        return toastr.success(message);
    }
  }
}